import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";

interface BookingDetailsDialogProps {
  booking: any;
  onClose: () => void;
  onUpdateStatus: (bookingId: string, newStatus: string) => Promise<void>;
}

export const BookingDetailsDialog = ({ booking, onClose, onUpdateStatus }: BookingDetailsDialogProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  return (
    <Dialog open={!!booking} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Booking Details</DialogTitle>
        </DialogHeader>
        {booking && (
          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h3 className="font-semibold mb-2">Property Information</h3>
                <p>{booking.property?.title}</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Guest Information</h3>
                <p>{booking.guest?.full_name}</p>
                <p className="text-sm text-muted-foreground">
                  {booking.guest?.phone_number}
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Check-in</h3>
                <p>{format(new Date(booking.check_in_date), "PPP")}</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Check-out</h3>
                <p>{format(new Date(booking.check_out_date), "PPP")}</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Payment Information</h3>
                <p>{formatCurrency(booking.total_price)}</p>
                <p className="text-sm text-muted-foreground">
                  via {booking.payment?.[0]?.provider}
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Status</h3>
                <Select
                  value={booking.status}
                  onValueChange={(value) => onUpdateStatus(booking.id, value)}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="pending">Pending</SelectItem>
                    <SelectItem value="confirmed">Confirmed</SelectItem>
                    <SelectItem value="cancelled">Cancelled</SelectItem>
                    <SelectItem value="completed">Completed</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="flex justify-end space-x-4">
              {booking.status === "pending" && (
                <>
                  <Button
                    variant="destructive"
                    onClick={() => onUpdateStatus(booking.id, "declined")}
                  >
                    Decline
                  </Button>
                  <Button
                    onClick={() => onUpdateStatus(booking.id, "approved")}
                  >
                    Approve
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};